import React from "react";
import { useTranslation } from "react-i18next";
import DashboardSidebarMenu from "../../../components/controls/DashboardSideBarMenu";
import { getRepresentativeMenus } from "../../../contexts/RepresentativesMenus";

export default function RepresentativeDashboard() {
  const { t } = useTranslation();
  const title = t("navbar.representative");
  const menus = getRepresentativeMenus();

  return (
    <div className="flex">
      {/* Sidebar */}
      <DashboardSidebarMenu title={title} menus={menus} />

      {/* Main content */}
      <div className="flex-1 p-6 text-onWhite">
        <h1>{t("representatives.dashboardDescription")}</h1>
      </div>
    </div>
  );
}
